/** Carte container avec titre optionnel */

import type { ReactNode } from 'react';
import { cn } from '../../lib/utils';

interface CardProps {
  title?: string;
  children: ReactNode;
  className?: string;
  action?: ReactNode;
  /** Supprime le padding intérieur — utile quand le contenu gère le sien */
  noPadding?: boolean;
}

export function Card({ title, children, className, action, noPadding }: CardProps) {
  return (
    <div
      className={cn(
        'bg-white rounded-xl border border-stone-200/80 shadow-soft',
        className
      )}
    >
      {(title || action) && (
        <div className="flex items-center justify-between px-5 py-3 border-b border-stone-100">
          {title && <h3 className="text-sm font-semibold text-ink">{title}</h3>}
          {action}
        </div>
      )}
      <div className={noPadding ? '' : 'p-5'}>{children}</div>
    </div>
  );
}
